<div class="flex min-h-screen items-center justify-center bg-zinc-950 px-4 py-12 font-sans">
  <div class="w-full max-w-sm">

    <!-- Logo + heading -->
    <div class="mb-8 flex flex-col items-center text-center">
      <div class="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-600 shadow-sm">
        <lucide-icon name="shield" [size]="22" color="white" [strokeWidth]="2.5"></lucide-icon>
      </div>
      <h1 class="text-xl font-semibold text-white">Admin Console</h1>
      <p class="mt-1.5 text-sm text-zinc-400">Sign in with your admin account</p>
    </div>

    <!-- Card -->
    <div class="rounded-xl border border-zinc-800 bg-zinc-900 px-6 py-7">
      <form #loginForm="ngForm" (ngSubmit)="onSubmit()">

        <!-- Error banner -->
        <div *ngIf="error" class="mb-5 flex items-start gap-2.5 rounded-lg border border-red-800/50 bg-red-950/50 px-4 py-3">
          <lucide-icon name="triangle-alert" [size]="15" class="mt-0.5 flex-shrink-0 text-red-400" [strokeWidth]="2"></lucide-icon>
          <p class="text-sm text-red-300">{{ error }}</p>
        </div>

        <!-- Email -->
        <div class="mb-4">
          <label for="username" class="mb-1.5 block text-xs font-medium text-zinc-400">Email</label>
          <input
            id="username"
            type="email"
            name="username"
            [(ngModel)]="username"
            required
            autocomplete="email"
            placeholder="admin@kernalhq.com"
            class="block w-full rounded-lg border border-zinc-700 bg-zinc-800 px-3.5 py-2.5 text-sm text-white placeholder:text-zinc-600 focus:border-violet-500 focus:outline-none focus:ring-2 focus:ring-violet-500/20"
          />
        </div>

        <!-- Password -->
        <div class="mb-6">
          <label for="password" class="mb-1.5 block text-xs font-medium text-zinc-400">Password</label>
          <input
            id="password"
            type="password"
            name="password"
            [(ngModel)]="password"
            required
            autocomplete="current-password"
            placeholder="••••••••••••"
            class="block w-full rounded-lg border border-zinc-700 bg-zinc-800 px-3.5 py-2.5 text-sm text-white placeholder:text-zinc-600 focus:border-violet-500 focus:outline-none focus:ring-2 focus:ring-violet-500/20"
          />
        </div>

        <button
          type="submit"
          [disabled]="loading || !loginForm.valid"
          class="flex w-full items-center justify-center gap-2 rounded-lg bg-violet-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 focus:ring-offset-zinc-900 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <lucide-icon *ngIf="loading" name="loader" [size]="15" class="animate-spin" [strokeWidth]="2.5"></lucide-icon>
          {{ loading ? 'Signing in...' : 'Sign in' }}
        </button>

      </form>
    </div>

    <p class="mt-6 text-center text-xs text-zinc-600">Internal use only &mdash; KernalHQ Operations</p>
  </div>
</div>
